import React from 'react';
import { Badge } from './ui/badge';
import { Sparkles } from 'lucide-react';

/**
 * Iter-168 Phase 3 — Top Profile badge.
 * Shown to clients when talent.profile_quality_score >= 85 OR is_top_profile=true.
 * Reward signal — never punitive.
 */
export const TopProfileBadge = ({ size = 'sm', testIdSuffix = '' }) => (
  <Badge
    className={`bg-gradient-to-r from-cyan-500 via-cyan-400 to-emerald-400 text-white border-0 shadow-[0_2px_12px_rgba(6,182,212,0.35)] ${
      size === 'xs' ? 'text-[10px] px-1.5 py-0' : 'text-[11px] px-2 py-0.5'
    } font-semibold inline-flex items-center gap-1`}
    data-testid={`top-profile-badge${testIdSuffix ? `-${testIdSuffix}` : ''}`}
  >
    <Sparkles className={size === 'xs' ? 'w-2.5 h-2.5' : 'w-3 h-3'} />
    Top Profile
  </Badge>
);

export const ResponsiveBadge = ({ size = 'sm', testIdSuffix = '' }) => (
  <Badge
    variant="outline"
    className={`bg-emerald-50 text-emerald-700 border-emerald-200 ${
      size === 'xs' ? 'text-[10px] px-1.5 py-0' : 'text-[11px] px-2 py-0.5'
    }`}
    data-testid={`responsive-badge${testIdSuffix ? `-${testIdSuffix}` : ''}`}
  >
    Responsive
  </Badge>
);

export default TopProfileBadge;
